/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { broadcastScheduleControllerCancelV1 } from '../fn/broadcast-schedule/broadcast-schedule-controller-cancel-v-1';
import { BroadcastScheduleControllerCancelV1$Params } from '../fn/broadcast-schedule/broadcast-schedule-controller-cancel-v-1';
import { broadcastScheduleControllerCreateV1 } from '../fn/broadcast-schedule/broadcast-schedule-controller-create-v-1';
import { BroadcastScheduleControllerCreateV1$Params } from '../fn/broadcast-schedule/broadcast-schedule-controller-create-v-1';
import { broadcastScheduleControllerDeleteV1 } from '../fn/broadcast-schedule/broadcast-schedule-controller-delete-v-1';
import { BroadcastScheduleControllerDeleteV1$Params } from '../fn/broadcast-schedule/broadcast-schedule-controller-delete-v-1';
import { broadcastScheduleControllerFindAllV1 } from '../fn/broadcast-schedule/broadcast-schedule-controller-find-all-v-1';
import { BroadcastScheduleControllerFindAllV1$Params } from '../fn/broadcast-schedule/broadcast-schedule-controller-find-all-v-1';
import { broadcastScheduleControllerFindByEventIdV1 } from '../fn/broadcast-schedule/broadcast-schedule-controller-find-by-event-id-v-1';
import { BroadcastScheduleControllerFindByEventIdV1$Params } from '../fn/broadcast-schedule/broadcast-schedule-controller-find-by-event-id-v-1';
import { broadcastScheduleControllerFindByIdV1 } from '../fn/broadcast-schedule/broadcast-schedule-controller-find-by-id-v-1';
import { BroadcastScheduleControllerFindByIdV1$Params } from '../fn/broadcast-schedule/broadcast-schedule-controller-find-by-id-v-1';
import { broadcastScheduleControllerSearchCursorV1 } from '../fn/broadcast-schedule/broadcast-schedule-controller-search-cursor-v-1';
import { BroadcastScheduleControllerSearchCursorV1$Params } from '../fn/broadcast-schedule/broadcast-schedule-controller-search-cursor-v-1';
import { broadcastScheduleControllerSearchV1 } from '../fn/broadcast-schedule/broadcast-schedule-controller-search-v-1';
import { BroadcastScheduleControllerSearchV1$Params } from '../fn/broadcast-schedule/broadcast-schedule-controller-search-v-1';
import { broadcastScheduleControllerUpdateV1 } from '../fn/broadcast-schedule/broadcast-schedule-controller-update-v-1';
import { BroadcastScheduleControllerUpdateV1$Params } from '../fn/broadcast-schedule/broadcast-schedule-controller-update-v-1';
import { BroadcastScheduleDto } from '../models/broadcast-schedule-dto';
import { CursorPaginationDto } from '../models/cursor-pagination-dto';
import { OffsetPaginationDto } from '../models/offset-pagination-dto';

@Injectable({ providedIn: 'root' })
export class BroadcastScheduleService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `broadcastScheduleControllerSearchV1()` */
  static readonly BroadcastScheduleControllerSearchV1Path = '/api/v1/broadcast-schedule/search';

  /**
   * 방송 스케줄 검색.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `broadcastScheduleControllerSearchV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  broadcastScheduleControllerSearchV1$Response(params?: BroadcastScheduleControllerSearchV1$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto & {
'items'?: Array<BroadcastScheduleDto>;
}>> {
    return broadcastScheduleControllerSearchV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 방송 스케줄 검색.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `broadcastScheduleControllerSearchV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  broadcastScheduleControllerSearchV1(params?: BroadcastScheduleControllerSearchV1$Params, context?: HttpContext): Observable<OffsetPaginationDto & {
'items'?: Array<BroadcastScheduleDto>;
}> {
    return this.broadcastScheduleControllerSearchV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto & {
'items'?: Array<BroadcastScheduleDto>;
}>): OffsetPaginationDto & {
'items'?: Array<BroadcastScheduleDto>;
} => r.body)
    );
  }

  /** Path part for operation `broadcastScheduleControllerSearchCursorV1()` */
  static readonly BroadcastScheduleControllerSearchCursorV1Path = '/api/v1/broadcast-schedule/search/cursor';

  /**
   * 방송 스케줄 커서 기반 검색.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `broadcastScheduleControllerSearchCursorV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  broadcastScheduleControllerSearchCursorV1$Response(params?: BroadcastScheduleControllerSearchCursorV1$Params, context?: HttpContext): Observable<StrictHttpResponse<CursorPaginationDto & {
'items'?: Array<BroadcastScheduleDto>;
}>> {
    return broadcastScheduleControllerSearchCursorV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 방송 스케줄 커서 기반 검색.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `broadcastScheduleControllerSearchCursorV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  broadcastScheduleControllerSearchCursorV1(params?: BroadcastScheduleControllerSearchCursorV1$Params, context?: HttpContext): Observable<CursorPaginationDto & {
'items'?: Array<BroadcastScheduleDto>;
}> {
    return this.broadcastScheduleControllerSearchCursorV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<CursorPaginationDto & {
'items'?: Array<BroadcastScheduleDto>;
}>): CursorPaginationDto & {
'items'?: Array<BroadcastScheduleDto>;
} => r.body)
    );
  }

  /** Path part for operation `broadcastScheduleControllerFindAllV1()` */
  static readonly BroadcastScheduleControllerFindAllV1Path = '/api/v1/broadcast-schedule';

  /**
   * 모든 방송 스케줄 목록 조회.
   *
   * status 쿼리 파라미터로 필터링 가능
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `broadcastScheduleControllerFindAllV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  broadcastScheduleControllerFindAllV1$Response(params?: BroadcastScheduleControllerFindAllV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BroadcastScheduleDto>>> {
    return broadcastScheduleControllerFindAllV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 모든 방송 스케줄 목록 조회.
   *
   * status 쿼리 파라미터로 필터링 가능
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `broadcastScheduleControllerFindAllV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  broadcastScheduleControllerFindAllV1(params?: BroadcastScheduleControllerFindAllV1$Params, context?: HttpContext): Observable<Array<BroadcastScheduleDto>> {
    return this.broadcastScheduleControllerFindAllV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<BroadcastScheduleDto>>): Array<BroadcastScheduleDto> => r.body)
    );
  }

  /** Path part for operation `broadcastScheduleControllerCreateV1()` */
  static readonly BroadcastScheduleControllerCreateV1Path = '/api/v1/broadcast-schedule';

  /**
   * 방송 스케줄 생성.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `broadcastScheduleControllerCreateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  broadcastScheduleControllerCreateV1$Response(params: BroadcastScheduleControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<BroadcastScheduleDto>> {
    return broadcastScheduleControllerCreateV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 방송 스케줄 생성.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `broadcastScheduleControllerCreateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  broadcastScheduleControllerCreateV1(params: BroadcastScheduleControllerCreateV1$Params, context?: HttpContext): Observable<BroadcastScheduleDto> {
    return this.broadcastScheduleControllerCreateV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<BroadcastScheduleDto>): BroadcastScheduleDto => r.body)
    );
  }

  /** Path part for operation `broadcastScheduleControllerFindByEventIdV1()` */
  static readonly BroadcastScheduleControllerFindByEventIdV1Path = '/api/v1/broadcast-schedule/event/{eventId}';

  /**
   * 특정 행사의 방송 스케줄 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `broadcastScheduleControllerFindByEventIdV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  broadcastScheduleControllerFindByEventIdV1$Response(params: BroadcastScheduleControllerFindByEventIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BroadcastScheduleDto>>> {
    return broadcastScheduleControllerFindByEventIdV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 특정 행사의 방송 스케줄 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `broadcastScheduleControllerFindByEventIdV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  broadcastScheduleControllerFindByEventIdV1(params: BroadcastScheduleControllerFindByEventIdV1$Params, context?: HttpContext): Observable<Array<BroadcastScheduleDto>> {
    return this.broadcastScheduleControllerFindByEventIdV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<BroadcastScheduleDto>>): Array<BroadcastScheduleDto> => r.body)
    );
  }

  /** Path part for operation `broadcastScheduleControllerFindByIdV1()` */
  static readonly BroadcastScheduleControllerFindByIdV1Path = '/api/v1/broadcast-schedule/{id}';

  /**
   * 방송 스케줄 id로 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `broadcastScheduleControllerFindByIdV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  broadcastScheduleControllerFindByIdV1$Response(params: BroadcastScheduleControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<BroadcastScheduleDto>> {
    return broadcastScheduleControllerFindByIdV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 방송 스케줄 id로 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `broadcastScheduleControllerFindByIdV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  broadcastScheduleControllerFindByIdV1(params: BroadcastScheduleControllerFindByIdV1$Params, context?: HttpContext): Observable<BroadcastScheduleDto> {
    return this.broadcastScheduleControllerFindByIdV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<BroadcastScheduleDto>): BroadcastScheduleDto => r.body)
    );
  }

  /** Path part for operation `broadcastScheduleControllerDeleteV1()` */
  static readonly BroadcastScheduleControllerDeleteV1Path = '/api/v1/broadcast-schedule/{id}';

  /**
   * 방송 스케줄 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `broadcastScheduleControllerDeleteV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  broadcastScheduleControllerDeleteV1$Response(params: BroadcastScheduleControllerDeleteV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return broadcastScheduleControllerDeleteV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 방송 스케줄 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `broadcastScheduleControllerDeleteV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  broadcastScheduleControllerDeleteV1(params: BroadcastScheduleControllerDeleteV1$Params, context?: HttpContext): Observable<boolean> {
    return this.broadcastScheduleControllerDeleteV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `broadcastScheduleControllerUpdateV1()` */
  static readonly BroadcastScheduleControllerUpdateV1Path = '/api/v1/broadcast-schedule/{id}';

  /**
   * 방송 스케줄 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `broadcastScheduleControllerUpdateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  broadcastScheduleControllerUpdateV1$Response(params: BroadcastScheduleControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<BroadcastScheduleDto>> {
    return broadcastScheduleControllerUpdateV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 방송 스케줄 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `broadcastScheduleControllerUpdateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  broadcastScheduleControllerUpdateV1(params: BroadcastScheduleControllerUpdateV1$Params, context?: HttpContext): Observable<BroadcastScheduleDto> {
    return this.broadcastScheduleControllerUpdateV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<BroadcastScheduleDto>): BroadcastScheduleDto => r.body)
    );
  }

  /** Path part for operation `broadcastScheduleControllerCancelV1()` */
  static readonly BroadcastScheduleControllerCancelV1Path = '/api/v1/broadcast-schedule/{id}/cancel';

  /**
   * 방송 스케줄 상태를 취소(CANCELLED)로 변경.
   *
   * 방송 스케줄의 상태를 CANCELLED로 명시적으로 변경합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `broadcastScheduleControllerCancelV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  broadcastScheduleControllerCancelV1$Response(params: BroadcastScheduleControllerCancelV1$Params, context?: HttpContext): Observable<StrictHttpResponse<BroadcastScheduleDto>> {
    return broadcastScheduleControllerCancelV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 방송 스케줄 상태를 취소(CANCELLED)로 변경.
   *
   * 방송 스케줄의 상태를 CANCELLED로 명시적으로 변경합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `broadcastScheduleControllerCancelV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  broadcastScheduleControllerCancelV1(params: BroadcastScheduleControllerCancelV1$Params, context?: HttpContext): Observable<BroadcastScheduleDto> {
    return this.broadcastScheduleControllerCancelV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<BroadcastScheduleDto>): BroadcastScheduleDto => r.body)
    );
  }

}
